<template lang="pug">
form(@submit.prevent="navigate('sistema.docModelos.edit.irregularidades')")
  p.text-large - Assuntos de OS-m para vistorias
  .columns
    .column.col-6.col-md-8.col-sm-12
      .columns
        .column.col-12
          form-group(label="Verificar notificação aguardando regularizar")
            assunto-picker(
              v-model="$v.resource.params.osm.assuntos.notificacao.$model"
            )
        .column.col-12
          form-group(label="Verificar pedido de desconto")
            assunto-picker(
              v-model="$v.resource.params.osm.assuntos.desconto.$model"
            )
        .column.col-12
          form-group(label="Verificar autuação")
            assunto-picker(
              v-model="$v.resource.params.osm.assuntos.autuacao.$model"
            )
        .column.col-12
          form-group(label="Entrega de documento")
            assunto-picker(
              v-model="$v.resource.params.osm.assuntos.entrega.$model"
            )
        .column.col-12
          form-group(label="Verificar notificação sem valor")
            assunto-picker(
              v-model="$v.resource.params.osm.assuntos.notificacao_sem_valor.$model"
            )
        .column.col-12
          form-group(label="Verificar pedido de prazo para regularizar")
            assunto-picker(
              v-model="$v.resource.params.osm.assuntos.prazo_regularizar.$model"
            )
  .pt-2
    .divider
    button.btn.btn-primary(:disabled="$v.resource.$invalid")
      btn-content(name="next")
</template>

<script>
import editMixin from "./mixin"

export default {
  mixins: [editMixin],
  validations: {
    resource: {
      params: {
        osm: {
          assuntos: {
            autuacao: {},
            desconto: {},
            notificacao: {},
            entrega: {},
            notificacao_sem_valor: {},
            prazo_regularizar: {},
          },
        },
      },
    },
  },
}
</script>
